import { gql } from 'graphql-tag';

export const MemberInfoFragment = gql`
  fragment MemberInfo on MemberType {
    email
    firstname
    lastname
    preferredName
    phoneNumber
    exists
    dob
    gender
  }
`;
